import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "user-assignment" }
const _hoisted_2 = { class: "buttons" }
const _hoisted_3 = { key: 0 }

import { UserProjectItem, UserProjectParticipationItem } from "@/services/entities/UserProjectItem";
import { useUserStore } from "@/stores/user";
import { onMounted, reactive } from "vue";
import VueSelect from "vue-select";

import DxButton from 'devextreme-vue/button';
import { getKey } from "@/common/util";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAssignment',
  props: {
    users: { Type: [] as UserProjectItem[], default: [] as UserProjectItem[] },
    projectStart: Date,
    projectEnd: Date
},
  emits: ['save'],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore();

const props = __props;

onMounted(async () => {
    await userStore.loadAll();
});

const emit = __emit

const state = reactive({
    edit: false
});

function saveUsers(): void {
    // props.users.forEach(element => {
    //     element.range = element.range.map((a: any) => new Date(a.year, a.month))
    // });

    let result = props.users.filter(a => a.userId && a.participations.length > 0);
    result.forEach(a => {
        a.participations.forEach((b: any) => {
            if (b.monthRange) {
                let c = b.monthRange[0];
                b.range = [] as any;
                b.range[0] = new Date(Date.UTC(c.year, c.month));
                c = b.monthRange[1]
                b.range[1] = new Date(Date.UTC(c.year, c.month + 1, 0));
            }
        });
    });
    emit('save', result);
}

function addUser(): void {
    props.users.push({ participations: [{} as UserProjectParticipationItem] } as unknown as UserProjectItem);
}

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.users, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: _unref(getKey)('users', index)
      }, [
        _createVNode(_unref(VueSelect), {
          modelValue: item.userId,
          "onUpdate:modelValue": ($event: any) => ((item.userId) = $event),
          options: _unref(userStore).getAll,
          label: "email",
          reduce: (item) => item.id,
          appendToBody: true,
          disabled: !state.edit,
          clearable: false
        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "reduce", "disabled"]),
        _createElementVNode("div", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.participations, (part, index) => {
            return (_openBlock(), _createBlock(_component_VueDatePicker, {
              key: _unref(getKey)('part', index),
              teleport: true,
              "min-date": props.projectStart,
              "max-date": props.projectEnd,
              modelValue: part.monthRange,
              "onUpdate:modelValue": ($event: any) => ((part.monthRange) = $event),
              range: "",
              "month-picker": "",
              disabled: !state.edit,
              onCleared: ($event: any) => (item.participations.splice(index, 1))
            }, null, 8, ["min-date", "max-date", "modelValue", "onUpdate:modelValue", "disabled", "onCleared"]))
          }), 128)),
          (state.edit)
            ? (_openBlock(), _createBlock(_unref(DxButton), {
                key: 0,
                icon: "add",
                text: "Add range",
                onClick: ($event: any) => (item.participations.push({}))
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (state.edit)
            ? (_openBlock(), _createBlock(_unref(DxButton), {
                key: 1,
                icon: "trash",
                hint: item.activitySummary?.hasReportedHours ? 'Cannot remove user with reported hours' : 'Remove user',
                onClick: ($event: any) => (props.users.splice(index, 1)),
                disabled: item.activitySummary?.hasReportedHours,
                class: "show-always-tooltip"
              }, null, 8, ["hint", "onClick", "disabled"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_2, [
      (state.edit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: addUser,
              class: _normalizeClass({ accent: !state.edit })
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("b", null, "+", -1),
              _createTextVNode("Add user", -1)
            ]))], 2),
            _createElementVNode("button", {
              class: "accent",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (saveUsers()))
            }, "Save")
          ]))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (state.edit = true)),
            class: _normalizeClass({ accent: !state.edit })
          }, "Edit assignment", 2))
    ])
  ]))
}
}

})